import { IUnderwritingQuoteExcessLayerParticipant } from '@converge/graphql';

export const getLayerLimitFromParticipants = (
  participants: IUnderwritingQuoteExcessLayerParticipant[]
) => {
  return participants.reduce((acc, participant) => {
    return acc + (participant.quote?.limit ?? 0);
  }, 0);
};
